import axios from "axios";

/**
 * Fetches the assistance token
 * @param {String} tokenValue The value of the assistance token
 * @param {String} bearer The bearer token
 * @returns The assistance token
 */
export const fetchTokenByValue = async (tokenValue, bearer) => {
  try {
    const response = await axios.get(
      process.env.REACT_APP_BASE_URL_REST_API_TOKEN,
      {
        headers: {
          Authorization: `Bearer ${bearer}`,
        },
        params: {
          token_value: tokenValue,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error(error);
  }
};

/**
 * Fetches the token by assistance request id
 * @param {String} requestId The assistance request identifier
 * @param {String} bearer The bearer token
 * @returns The assistance token
 */
export const fetchTokenByRequest = async (requestId, bearer) => {
  try {
    const response = await axios.get(
      process.env.REACT_APP_BASE_URL_REST_API_TOKEN,
      {
        headers: {
          Authorization: `Bearer ${bearer}`,
        },
        params: {
          request_id: requestId,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error(error);
  }
};
